import {priority} from '@priority-software/priority-proto-api/lib';
import {Column} from '../../../stores/Form/Column';
import {fieldValue} from '../../../stores/Form/Field';
import {getDecimalSign} from './number';

export function getPlaceholderByColumn(column: Column, lang: string): fieldValue {
    if (column.Type === priority.netitems.form.ColumnType.Boolean) {
        return false;
    }
    if (column.Type === priority.netitems.form.ColumnType.Time5) {
        return lang === '3' ? '12:00 AM' : '00:00';
    }
    if (column.Type === priority.netitems.form.ColumnType.Time6) {
        return '000:00';
    }
    if (column.Type === priority.netitems.form.ColumnType.Real) {
        return `0${getDecimalSign()}${'0'.repeat(column.decimal)}`;
    }
    if (column.Type === priority.netitems.form.ColumnType.Int) {
        return '0';
    }
    return '';
}
